module.exports = __webpack_public_path__ + "media/images/speeltuin-3606e8cdcc04fb4ba74eec57c12f9f10.jpg";